import { tolgee } from './tolgee';
import { logger } from 'services/logger';

/**
 * 判断是否存在 i18n key
 * @param key i18n key
 * @param language 系统语言
 * @param ns 命名空间
 * @returns
 */
export const i18nExist = (key: string, ns?: string, language?: General.SystemLanguage) => {
  const lang = language || tolgee.getLanguage();
  if (lang) {
    const records = tolgee.getRecord({ language: lang, namespace: ns });
    if (records?.data) {
      return !!records.data[key];
    }
  }
  return false;
};

const missingKeyMap = new Set<string>();

export const reportMissingKey = (key: string) => {
  // 缺失上报自身不允许抛错：key 异常（undefined/空）时 Tolgee DevTools 已有告警，无补词上报价值
  if (!key) return;
  if (!missingKeyMap.has(key)) {
    missingKeyMap.add(key);
    logger.warn(`[Missing i18n Key] key: ${key}, language: ${tolgee.getLanguage() || ''}`);

    const isTikTokReturnReason = key.startsWith('tiktok.returnReason.');
    if (isTikTokReturnReason) {
      // 上报缺失的 TikTok 退货原因翻译 key，方便后续补齐翻译
      logger.warn(
        `[Missing i18n Key][TikTok Return Reason] key: ${key}, language: ${
          tolgee.getLanguage() || ''
        }`,
      );
    }
  }
};

export const getShopeeLocalMultipleAuthTemplateFile = (language: General.SystemLanguage) => {
  const m: any = {
    'zh-CN': import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE,
    'en-US': import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_EN,
    id: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_ID,
    th: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_TH,
    tl: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_TL,
    vi: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_VI,
    pt: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_PT,
    my: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_MY,
    es: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_EN,
  };
  return m[language];
};

export const getShopeeCrossMultipleAuthTemplateFile = (language: General.SystemLanguage) => {
  const m: any = {
    'zh-CN': import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE,
    'en-US': import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_EN,
    id: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_ID,
    th: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_TH,
    tl: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_TL,
    vi: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_VI,
    pt: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_PT,
    my: import.meta.env.VITE_SHOPE_MULTI_AUTH_CROSS_TEMPLATE_MY,
    es: import.meta.env.VITE_SHOPE_MULTI_AUTH_LOCAL_TEMPLATE_EN,
  };
  return m[language];
};

export const loadResources = (files: Promise<Record<string, string>>[]) => {
  return Promise.all(files).then((res) => {
    return res.reduce((acc, curr) => {
      return Object.assign(acc, curr);
    }, {} as Record<string, string>);
  });
};
